export const singleCodePrefixRegex = (prefix: string): string =>
  `^${prefix}.*$`;
